import { Redirect } from 'react-router-dom'

import { interpUri } from '@b-stock/fe-core/bstock-react'

import useUserInfo from '@helpers/useUserInfo'

import Components from '../Components'
import type { RouteDefinitions } from '../Router'
import MyAccountRedirect from '../shared/MyAccountRedirect'
import businessProfileRoutes from './businessProfileRoutes'
import HpSettingsRedirect from './HpSettingsRedirect'

const OldPersonalSettingsRedirect = () => {
  const { personId } = useUserInfo()
  if (!personId) {
    return <Redirect to="/signin" />
  }
  return <Redirect to={interpUri`/settings/${personId}/personal`} />
}

const settingsRoutes = {
  settings: {
    path: '/settings',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account">
        <Components.SettingsPage />
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  personalSettings: {
    path: '/settings/:personId/personal',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/:personId/personal">
        <MyAccountRedirect paramName="personId">
          <Components.PersonalSettings />
        </MyAccountRedirect>
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  oldPersonalSettings: {
    path: '/settings/personal',
    exact: true,
    component: <OldPersonalSettingsRedirect />,
    requireAuth: true,
  },
  'payment-method': {
    path: '/settings/:accountId/payment-method',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/:accountId/payment-method">
        <MyAccountRedirect paramName="accountId" validateExistingParam>
          <Components.PaymentMethod />
        </MyAccountRedirect>
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  'notification-preferences': {
    path: '/settings/:personId/notification-preferences',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/:personId/notification-preferences">
        <MyAccountRedirect paramName="personId">
          <Components.NotificationPreferencesPage />
        </MyAccountRedirect>
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  'sms-preference': {
    path: '/settings/:personId/notification-preferences/sms-preferences',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/:personId/notification-preferences/sms-preferences">
        <MyAccountRedirect paramName="personId">
          <Components.SmsNotificationPage />
        </MyAccountRedirect>
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  'email-preference': {
    path: '/settings/:personId/notification-preferences/email-preferences',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/:personId/notification-preferences/email-preferences">
        <MyAccountRedirect paramName="personId">
          <Components.EmailNotificationPage />
        </MyAccountRedirect>
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  'business-profile': {
    router: true,
    path: '/settings/business-profile',
    routes: businessProfileRoutes,
  },
  'my-interests': {
    path: '/settings/buying-preferences',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/buying-preferences">
        <Components.MyInterestsPage />
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  'marketplace-restrictions': {
    path: '/settings/:accountId/marketplace-eligibility/:siteAbb',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/marketplace-eligibility/:siteAbb">
        <MyAccountRedirect paramName="accountId">
          <Components.MarketplaceRestrictionPage />
        </MyAccountRedirect>
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  'marketplace-eligibility': {
    path: '/settings/:accountId/marketplace-eligibility',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/marketplace-eligibility">
        <MyAccountRedirect paramName="accountId">
          <Components.MarketplaceEligibilityPage />
        </MyAccountRedirect>
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
} as const satisfies RouteDefinitions

export default settingsRoutes
